// extracted by mini-css-extract-plugin
module.exports = {"ability":"CharacterSheetAbilities_ability_tSubV","modifier":"CharacterSheetAbilities_modifier_t-h13"};